import { Helmet } from 'react-helmet-async';
import { Box, Container, Typography } from '@mui/material';
import { PageWithLayout } from '@/models/page';
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';

const UnAuthorized: PageWithLayout = () => {
    return (
        <>
            <Helmet>
                <title>Kein Zugriff | Starjack Admin</title>
            </Helmet>
            <Box
                component='main'
                sx={{
                    alignItems: 'center',
                    display: 'flex',
                    flexGrow: 1,
                    minHeight: '100%',
                }}
            >
                <Container maxWidth='md'>
                    <Box
                        sx={{
                            alignItems: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                    >
                        <Typography
                            align='center'
                            sx={{ mb: 3 }}
                            variant='h3'
                            color='error'
                        >
                            Kein Zugriff
                        </Typography>
                        <Typography
                            align='center'
                            color='text.secondary'
                            variant='body1'
                        >
                            Für diese Seite fehlt die Berechtigung. Bitte den
                            Administrator kontaktieren.
                        </Typography>
                    </Box>
                </Container>
            </Box>
        </>
    );
};

UnAuthorized.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;
UnAuthorized.isProtected = true;
UnAuthorized.permissions = [];

export default UnAuthorized;
